import { useEffect, useState } from "react";
import RequirementsHeroSection from "./RequirementsHeroSection";
import { useNavigate } from "react-router";
import { path } from "../../../utils/common/constant";
import { useTranslation } from "react-i18next";

interface CountryGroup {
  region: string;
  countries: {
    name: string;
    code: string;
    japaneseName: string;
    chineseName: string;
    koreanName: string;
  }[];
}

const VisaRequirements = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [selectedCountry, setSelectedCountry] = useState<string | undefined>(
    ""
  );

  const countryGroups: CountryGroup[] = [
    {
      region: t("apply_visa.continents.africa"),
      countries: [
        {
          name: "Algeria",
          code: "DZ",
          japaneseName: "アルジェリア",
          chineseName: "阿尔及利亚",
          koreanName: "알제리"
        },
        {
          name: "Angola",
          code: "AO",
          japaneseName: "アンゴラ",
          chineseName: "安哥拉",
          koreanName: "앙골라"
        },
        {
          name: "Benin",
          code: "BJ",
          japaneseName: "ベナン",
          chineseName: "贝宁",
          koreanName: "베냉"
        },
        {
          name: "Botswana",
          code: "BW",
          japaneseName: "ボツワナ",
          chineseName: "博茨瓦纳",
          koreanName: "보츠와나"
        },
        {
          name: "Burkina Faso",
          code: "BF",
          japaneseName: "ブルキナファソ",
          chineseName: "布基纳法索",
          koreanName: "부르키나파소"
        },
        {
          name: "Burundi",
          code: "BI",
          japaneseName: "ブルンジ",
          chineseName: "布隆迪",
          koreanName: "부룬디"
        },
        {
          name: "Cabo Verde",
          code: "CV",
          japaneseName: "カーボベルデ",
          chineseName: "佛得角",
          koreanName: "카보베르데"
        },
        {
          name: "Cameroon",
          code: "CM",
          japaneseName: "カメルーン",
          chineseName: "喀麦隆",
          koreanName: "카메룬"
        },
        {
          name: "Central African Republic",
          code: "CF",
          japaneseName: "中央アフリカ共和国",
          chineseName: "中非共和国",
          koreanName: "중앙아프리카공화국"
        },
        {
          name: "Chad",
          code: "TD",
          japaneseName: "チャド",
          chineseName: "乍得",
          koreanName: "차드"
        },
        {
          name: "Comoros",
          code: "KM",
          japaneseName: "コモロ",
          chineseName: "科摩罗",
          koreanName: "코모로"
        },
        {
          name: "Democratic Congo",
          code: "CD",
          japaneseName: "コンゴ民主共和国",
          chineseName: "刚果民主共和国",
          koreanName: "콩고민주공화국"
        },
        {
          name: "Congo",
          code: "CG",
          japaneseName: "コンゴ共和国",
          chineseName: "刚果共和国",
          koreanName: "콩고공화국"
        },
        {
          name: "Djibouti",
          code: "DJ",
          japaneseName: "ジブチ",
          chineseName: "吉布提",
          koreanName: "지부티"
        },
        {
          name: "Egypt",
          code: "EG",
          japaneseName: "エジプト",
          chineseName: "埃及",
          koreanName: "이집트"
        },
        {
          name: "Equatorial Guinea",
          code: "GQ",
          japaneseName: "赤道ギニア",
          chineseName: "赤道几内亚",
          koreanName: "적도기니"
        },
        {
          name: "Eritrea",
          code: "ER",
          japaneseName: "エリトリア",
          chineseName: "厄立特里亚",
          koreanName: "에리트레아"
        },
        {
          name: "Eswatini",
          code: "SZ",
          japaneseName: "エスワティニ",
          chineseName: "斯威士兰",
          koreanName: "에스와티니"
        },
        {
          name: "Ethiopia",
          code: "ET",
          japaneseName: "エチオピア",
          chineseName: "埃塞俄比亚",
          koreanName: "에티오피아"
        },
        {
          name: "Gabon",
          code: "GA",
          japaneseName: "ガボン",
          chineseName: "加蓬",
          koreanName: "가봉"
        },
        {
          name: "Gambia",
          code: "GM",
          japaneseName: "ガンビア",
          chineseName: "冈比亚",
          koreanName: "감비아"
        },
        {
          name: "Ghana",
          code: "GH",
          japaneseName: "ガーナ",
          chineseName: "加纳",
          koreanName: "가나"
        },
        {
          name: "Guinea",
          code: "GN",
          japaneseName: "ギニア",
          chineseName: "几内亚",
          koreanName: "기니"
        },
        {
          name: "Guinea-Bissau",
          code: "GW",
          japaneseName: "ギニアビサウ",
          chineseName: "几内亚比绍",
          koreanName: "기니비사우"
        },
        {
          name: "Ivory Coast",
          code: "CI",
          japaneseName: "コートジボワール",
          chineseName: "科特迪瓦",
          koreanName: "코트디부아르"
        },
        {
          name: "Kenya",
          code: "KE",
          japaneseName: "ケニア",
          chineseName: "肯尼亚",
          koreanName: "케냐"
        },
        {
          name: "Lesotho",
          code: "LS",
          japaneseName: "レソト",
          chineseName: "莱索托",
          koreanName: "레소토"
        },
        {
          name: "Liberia",
          code: "LR",
          japaneseName: "リベリア",
          chineseName: "利比里亚",
          koreanName: "라이베리아"
        },
        {
          name: "Libya",
          code: "LY",
          japaneseName: "リビア",
          chineseName: "利比亚",
          koreanName: "리비아"
        },
        {
          name: "Madagascar",
          code: "MG",
          japaneseName: "マダガスカル",
          chineseName: "马达加斯加",
          koreanName: "마다가스카르"
        },
        {
          name: "Malawi",
          code: "MW",
          japaneseName: "マラウイ",
          chineseName: "马拉维",
          koreanName: "말라위"
        },
        {
          name: "Mali",
          code: "ML",
          japaneseName: "マリ",
          chineseName: "马里",
          koreanName: "말리"
        },
        {
          name: "Mauritania",
          code: "MR",
          japaneseName: "モーリタニア",
          chineseName: "毛里塔尼亚",
          koreanName: "모리타니"
        },
        {
          name: "Mauritius",
          code: "MU",
          japaneseName: "モーリシャス",
          chineseName: "毛里求斯",
          koreanName: "모리셔스"
        },
        {
          name: "Morocco",
          code: "MA",
          japaneseName: "モロッコ",
          chineseName: "摩洛哥",
          koreanName: "모로코"
        },
        {
          name: "Mozambique",
          code: "MZ",
          japaneseName: "モザンビーク",
          chineseName: "莫桑比克",
          koreanName: "모잠비크"
        },
        {
          name: "Namibia",
          code: "NA",
          japaneseName: "ナミビア",
          chineseName: "纳米比亚",
          koreanName: "나미비아"
        },
        {
          name: "Niger",
          code: "NE",
          japaneseName: "ニジェール",
          chineseName: "尼日尔",
          koreanName: "니제르"
        },
        {
          name: "Nigeria",
          code: "NG",
          japaneseName: "ナイジェリア",
          chineseName: "尼日利亚",
          koreanName: "나이지리아"
        },
        {
          name: "Rwanda",
          code: "RW",
          japaneseName: "ルワンダ",
          chineseName: "卢旺达",
          koreanName: "르완다"
        },
        {
          name: "Sao Tome and Principe",
          code: "ST",
          japaneseName: "サントメ・プリンシペ",
          chineseName: "圣多美和普林西比",
          koreanName: "상투메 프린시페"
        },
        {
          name: "Senegal",
          code: "SN",
          japaneseName: "セネガル",
          chineseName: "塞内加尔",
          koreanName: "세네갈"
        },
        {
          name: "Seychelles",
          code: "SC",
          japaneseName: "セーシェル",
          chineseName: "塞舌尔",
          koreanName: "세이셸"
        },
        {
          name: "Sierra Leone",
          code: "SL",
          japaneseName: "シエラレオネ",
          chineseName: "塞拉利昂",
          koreanName: "시에라리온"
        },
        {
          name: "Somalia",
          code: "SO",
          japaneseName: "ソマリア",
          chineseName: "索马里",
          koreanName: "소말리아"
        },
        {
          name: "South Africa",
          code: "ZA",
          japaneseName: "南アフリカ",
          chineseName: "南非",
          koreanName: "남아프리카 공화국"
        },
        {
          name: "South Sudan",
          code: "SS",
          japaneseName: "南スーダン",
          chineseName: "南苏丹",
          koreanName: "남수단"
        },
        {
          name: "Sudan",
          code: "SD",
          japaneseName: "スーダン",
          chineseName: "苏丹",
          koreanName: "수단"
        },
        {
          name: "Tanzania",
          code: "TZ",
          japaneseName: "タンザニア",
          chineseName: "坦桑尼亚",
          koreanName: "탄자니아"
        },
        {
          name: "Togo",
          code: "TG",
          japaneseName: "トーゴ",
          chineseName: "多哥",
          koreanName: "토고"
        },
        {
          name: "Tunisia",
          code: "TN",
          japaneseName: "チュニジア",
          chineseName: "突尼斯",
          koreanName: "튀니지"
        },
        {
          name: "Uganda",
          code: "UG",
          japaneseName: "ウガンダ",
          chineseName: "乌干达",
          koreanName: "우간다"
        },
        {
          name: "Zambia",
          code: "ZM",
          japaneseName: "ザンビア",
          chineseName: "赞比亚",
          koreanName: "잠비아"
        },
        {
          name: "Zimbabwe",
          code: "ZW",
          japaneseName: "ジンバブエ",
          chineseName: "津巴布韦",
          koreanName: "짐바브웨"
        }
      ]
    },
    {
      region: t("apply_visa.continents.asia"),
      countries: [
        {
          name: "Afghanistan",
          code: "AF",
          japaneseName: "アフガニスタン",
          chineseName: "阿富汗",
          koreanName: "아프가니스탄"
        },
        {
          name: "Armenia",
          code: "AM",
          japaneseName: "アルメニア",
          chineseName: "亚美尼亚",
          koreanName: "아르메니아"
        },
        {
          name: "Azerbaijan",
          code: "AZ",
          japaneseName: "アゼルバイジャン",
          chineseName: "阿塞拜疆",
          koreanName: "아제르바이잔"
        },
        {
          name: "Bahrain",
          code: "BH",
          japaneseName: "バーレーン",
          chineseName: "巴林",
          koreanName: "바레인"
        },
        {
          name: "Bangladesh",
          code: "BD",
          japaneseName: "バングラデシュ",
          chineseName: "孟加拉国",
          koreanName: "방글라데시"
        },
        {
          name: "Bhutan",
          code: "BT",
          japaneseName: "ブータン",
          chineseName: "不丹",
          koreanName: "부탄"
        },
        {
          name: "Brunei Darussalam",
          code: "BN",
          japaneseName: "ブルネイ",
          chineseName: "文莱",
          koreanName: "브루나이"
        },
        {
          name: "Cambodia",
          code: "KH",
          japaneseName: "カンボジア",
          chineseName: "柬埔寨",
          koreanName: "캄보디아"
        },
        {
          name: "China",
          code: "CN",
          japaneseName: "中国",
          chineseName: "中国",
          koreanName: "중국"
        },
        {
          name: "Cyprus",
          code: "CY",
          japaneseName: "キプロス",
          chineseName: "塞浦路斯",
          koreanName: "키프로스"
        },
        {
          name: "Georgia",
          code: "GE",
          japaneseName: "ジョージア",
          chineseName: "格鲁吉亚",
          koreanName: "조지아"
        },
        {
          name: "India",
          code: "IN",
          japaneseName: "インド",
          chineseName: "印度",
          koreanName: "인도"
        },
        {
          name: "Indonesia",
          code: "ID",
          japaneseName: "インドネシア",
          chineseName: "印度尼西亚",
          koreanName: "인도네시아"
        },
        {
          name: "Iran (Islamic Republic of)",
          code: "IR",
          japaneseName: "イラン",
          chineseName: "伊朗",
          koreanName: "이란"
        },
        {
          name: "Iraq",
          code: "IQ",
          japaneseName: "イラク",
          chineseName: "伊拉克",
          koreanName: "이라크"
        },
        {
          name: "Israel",
          code: "IL",
          japaneseName: "イスラエル",
          chineseName: "以色列",
          koreanName: "이스라엘"
        },
        {
          name: "Japan",
          code: "JP",
          japaneseName: "日本",
          chineseName: "日本",
          koreanName: "일본"
        },
        {
          name: "Jordan",
          code: "JO",
          japaneseName: "ヨルダン",
          chineseName: "约旦",
          koreanName: "요르단"
        },
        {
          name: "Kazakhstan",
          code: "KZ",
          japaneseName: "カザフスタン",
          chineseName: "哈萨克斯坦",
          koreanName: "카자흐스탄"
        },
        {
          name: "Kuwait",
          code: "KW",
          japaneseName: "クウェート",
          chineseName: "科威特",
          koreanName: "쿠웨이트"
        },
        {
          name: "Kyrgyzstan",
          code: "KG",
          japaneseName: "キルギス",
          chineseName: "吉尔吉斯斯坦",
          koreanName: "키르기스스탄"
        },
        {
          name: "Laos",
          code: "LA",
          japaneseName: "ラオス",
          chineseName: "老挝",
          koreanName: "라오스"
        },
        {
          name: "Lebanon",
          code: "LB",
          japaneseName: "レバノン",
          chineseName: "黎巴嫩",
          koreanName: "레바논"
        },
        {
          name: "Malaysia",
          code: "MY",
          japaneseName: "マレーシア",
          chineseName: "马来西亚",
          koreanName: "말레이시아"
        },
        {
          name: "Maldives",
          code: "MV",
          japaneseName: "モルディブ",
          chineseName: "马尔代夫",
          koreanName: "몰디브"
        },
        {
          name: "Mongolia",
          code: "MN",
          japaneseName: "モンゴル",
          chineseName: "蒙古",
          koreanName: "몽골"
        },
        {
          name: "Myanmar",
          code: "MM",
          japaneseName: "ミャンマー",
          chineseName: "缅甸",
          koreanName: "미얀마"
        },
        {
          name: "Nepal",
          code: "NP",
          japaneseName: "ネパール",
          chineseName: "尼泊尔",
          koreanName: "네팔"
        },
        {
          name: "North Korea",
          code: "KP",
          japaneseName: "北朝鮮",
          chineseName: "朝鲜",
          koreanName: "북한"
        },
        {
          name: "Oman",
          code: "OM",
          japaneseName: "オマーン",
          chineseName: "阿曼",
          koreanName: "오만"
        },
        {
          name: "Pakistan",
          code: "PK",
          japaneseName: "パキスタン",
          chineseName: "巴基斯坦",
          koreanName: "파키스탄"
        },
        {
          name: "Palestine, State of",
          code: "PS",
          japaneseName: "パレスチナ",
          chineseName: "巴勒斯坦",
          koreanName: "팔레스타인"
        },
        {
          name: "Philippines",
          code: "PH",
          japaneseName: "フィリピン",
          chineseName: "菲律宾",
          koreanName: "필리핀"
        },
        {
          name: "Qatar",
          code: "QA",
          japaneseName: "カタール",
          chineseName: "卡塔尔",
          koreanName: "카타르"
        },
        {
          name: "Saudi Arabia",
          code: "SA",
          japaneseName: "サウジアラビア",
          chineseName: "沙特阿拉伯",
          koreanName: "사우디아라비아"
        },
        {
          name: "Singapore",
          code: "SG",
          japaneseName: "シンガポール",
          chineseName: "新加坡",
          koreanName: "싱가포르"
        },
        {
          name: "South Korea",
          code: "KR",
          japaneseName: "韓国",
          chineseName: "韩国",
          koreanName: "한국"
        },
        {
          name: "Sri Lanka",
          code: "LK",
          japaneseName: "スリランカ",
          chineseName: "斯里兰卡",
          koreanName: "스리랑카"
        },
        {
          name: "Syria",
          code: "SY",
          japaneseName: "シリア",
          chineseName: "叙利亚",
          koreanName: "시리아"
        },
        {
          name: "Tajikistan",
          code: "TJ",
          japaneseName: "タジキスタン",
          chineseName: "塔吉克斯坦",
          koreanName: "타지키스탄"
        },
        {
          name: "Thailand",
          code: "TH",
          japaneseName: "タイ",
          chineseName: "泰国",
          koreanName: "태국"
        },
        {
          name: "Timor-Leste",
          code: "TL",
          japaneseName: "東ティモール",
          chineseName: "东帝汶",
          koreanName: "동티모르"
        },
        {
          name: "Turkmenistan",
          code: "TM",
          japaneseName: "トルクメニスタン",
          chineseName: "土库曼斯坦",
          koreanName: "투르크메니스탄"
        },
        {
          name: "United Arab Emirates",
          code: "AE",
          japaneseName: "アラブ首長国連邦",
          chineseName: "阿联酋",
          koreanName: "아랍에미리트"
        },
        {
          name: "Uzbekistan",
          code: "UZ",
          japaneseName: "ウズベキスタン",
          chineseName: "乌兹别克斯坦",
          koreanName: "우즈베키스탄"
        },
        {
          name: "Vietnam",
          code: "VN",
          japaneseName: "ベトナム",
          chineseName: "越南",
          koreanName: "베트남"
        },
        {
          name: "Yemen",
          code: "YE",
          japaneseName: "イエメン",
          chineseName: "也门",
          koreanName: "예멘"
        }
      ]
    },
    {
      region: t("apply_visa.continents.europe"),
      countries: [
        {
          name: "Albania",
          code: "AL",
          japaneseName: "アルバニア",
          chineseName: "阿尔巴尼亚",
          koreanName: "알바니아"
        },
        {
          name: "Andorra",
          code: "AD",
          japaneseName: "アンドラ",
          chineseName: "安道尔",
          koreanName: "안도라"
        },
        {
          name: "Armenia",
          code: "AM",
          japaneseName: "アルメニア",
          chineseName: "亚美尼亚",
          koreanName: "아르메니아"
        },
        {
          name: "Austria",
          code: "AT",
          japaneseName: "オーストリア",
          chineseName: "奥地利",
          koreanName: "오스트리아"
        },
        {
          name: "Azerbaijan",
          code: "AZ",
          japaneseName: "アゼルバイジャン",
          chineseName: "阿塞拜疆",
          koreanName: "아제르바이잔"
        },
        {
          name: "Belarus",
          code: "BY",
          japaneseName: "ベラルーシ",
          chineseName: "白俄罗斯",
          koreanName: "벨라루스"
        },
        {
          name: "Belgium",
          code: "BE",
          japaneseName: "ベルギー",
          chineseName: "比利时",
          koreanName: "벨기에"
        },
        {
          name: "Bosnia and Herzegovina",
          code: "BA",
          japaneseName: "ボスニア・ヘルツェゴビナ",
          chineseName: "波斯尼亚和黑塞哥维那",
          koreanName: "보스니아 헤르체고비나"
        },
        {
          name: "Bulgaria",
          code: "BG",
          japaneseName: "ブルガリア",
          chineseName: "保加利亚",
          koreanName: "불가리아"
        },
        {
          name: "Croatia",
          code: "HR",
          japaneseName: "クロアチア",
          chineseName: "克罗地亚",
          koreanName: "크로아티아"
        },
        {
          name: "Cyprus",
          code: "CY",
          japaneseName: "キプロス",
          chineseName: "塞浦路斯",
          koreanName: "키프로스"
        },
        {
          name: "Czechia",
          code: "CZ",
          japaneseName: "チェコ",
          chineseName: "捷克",
          koreanName: "체코"
        },
        {
          name: "Denmark",
          code: "DK",
          japaneseName: "デンマーク",
          chineseName: "丹麦",
          koreanName: "덴마크"
        },
        {
          name: "Estonia",
          code: "EE",
          japaneseName: "エストニア",
          chineseName: "爱沙尼亚",
          koreanName: "에스토니아"
        },
        {
          name: "Finland",
          code: "FI",
          japaneseName: "フィンランド",
          chineseName: "芬兰",
          koreanName: "핀란드"
        },
        {
          name: "France",
          code: "FR",
          japaneseName: "フランス",
          chineseName: "法国",
          koreanName: "프랑스"
        },
        {
          name: "Georgia",
          code: "GE",
          japaneseName: "ジョージア",
          chineseName: "格鲁吉亚",
          koreanName: "조지아"
        },
        {
          name: "Germany",
          code: "DE",
          japaneseName: "ドイツ",
          chineseName: "德国",
          koreanName: "독일"
        },
        {
          name: "Greece",
          code: "GR",
          japaneseName: "ギリシャ",
          chineseName: "希腊",
          koreanName: "그리스"
        },
        {
          name: "Hungary",
          code: "HU",
          japaneseName: "ハンガリー",
          chineseName: "匈牙利",
          koreanName: "헝가리"
        },
        {
          name: "Iceland",
          code: "IS",
          japaneseName: "アイスランド",
          chineseName: "冰岛",
          koreanName: "아이슬란드"
        },
        {
          name: "Ireland",
          code: "IE",
          japaneseName: "アイルランド",
          chineseName: "爱尔兰",
          koreanName: "아일랜드"
        },
        {
          name: "Italy",
          code: "IT",
          japaneseName: "イタリア",
          chineseName: "意大利",
          koreanName: "이탈리아"
        },
        {
          name: "Kazakhstan",
          code: "KZ",
          japaneseName: "カザフスタン",
          chineseName: "哈萨克斯坦",
          koreanName: "카자흐스탄"
        },
        {
          name: "Latvia",
          code: "LV",
          japaneseName: "ラトビア",
          chineseName: "拉脱维亚",
          koreanName: "라트비아"
        },
        {
          name: "Liechtenstein",
          code: "LI",
          japaneseName: "リヒテンシュタイン",
          chineseName: "列支敦士登",
          koreanName: "리히텐슈타인"
        },
        {
          name: "Lithuania",
          code: "LT",
          japaneseName: "リトアニア",
          chineseName: "立陶宛",
          koreanName: "리투아니아"
        },
        {
          name: "Luxembourg",
          code: "LU",
          japaneseName: "ルクセンブルク",
          chineseName: "卢森堡",
          koreanName: "룩셈부르크"
        },
        {
          name: "Malta",
          code: "MT",
          japaneseName: "マルタ",
          chineseName: "马耳他",
          koreanName: "몰타"
        },
        {
          name: "Moldova",
          code: "MD",
          japaneseName: "モルドバ",
          chineseName: "摩尔多瓦",
          koreanName: "몰도바"
        },
        {
          name: "Monaco",
          code: "MC",
          japaneseName: "モナコ",
          chineseName: "摩纳哥",
          koreanName: "모나코"
        },
        {
          name: "Montenegro",
          code: "ME",
          japaneseName: "モンテネグロ",
          chineseName: "黑山",
          koreanName: "몬테네그로"
        },
        {
          name: "Netherlands",
          code: "NL",
          japaneseName: "オランダ",
          chineseName: "荷兰",
          koreanName: "네덜란드"
        },
        {
          name: "North Macedonia",
          code: "MK",
          japaneseName: "北マケドニア",
          chineseName: "北马其顿",
          koreanName: "북마케도니아"
        },
        {
          name: "Norway",
          code: "NO",
          japaneseName: "ノルウェー",
          chineseName: "挪威",
          koreanName: "노르웨이"
        },
        {
          name: "Poland",
          code: "PL",
          japaneseName: "ポーランド",
          chineseName: "波兰",
          koreanName: "폴란드"
        },
        {
          name: "Portugal",
          code: "PT",
          japaneseName: "ポルトガル",
          chineseName: "葡萄牙",
          koreanName: "포르투갈"
        },
        {
          name: "Romania",
          code: "RO",
          japaneseName: "ルーマニア",
          chineseName: "罗马尼亚",
          koreanName: "루마니아"
        },
        {
          name: "Russia",
          code: "RU",
          japaneseName: "ロシア",
          chineseName: "俄罗斯",
          koreanName: "러시아"
        },
        {
          name: "San Marino",
          code: "SM",
          japaneseName: "サンマリノ",
          chineseName: "圣马力诺",
          koreanName: "산마리노"
        },
        {
          name: "Serbia",
          code: "RS",
          japaneseName: "セルビア",
          chineseName: "塞尔维亚",
          koreanName: "세르비아"
        },
        {
          name: "Slovakia",
          code: "SK",
          japaneseName: "スロバキア",
          chineseName: "斯洛伐克",
          koreanName: "슬로바키아"
        },
        {
          name: "Slovenia",
          code: "SI",
          japaneseName: "スロベニア",
          chineseName: "斯洛文尼亚",
          koreanName: "슬로베니아"
        },
        {
          name: "Spain",
          code: "ES",
          japaneseName: "スペイン",
          chineseName: "西班牙",
          koreanName: "스페인"
        },
        {
          name: "Sweden",
          code: "SE",
          japaneseName: "スウェーデン",
          chineseName: "瑞典",
          koreanName: "스웨덴"
        },
        {
          name: "Switzerland",
          code: "CH",
          japaneseName: "スイス",
          chineseName: "瑞士",
          koreanName: "스위스"
        },
        {
          name: "Turkey",
          code: "TR",
          japaneseName: "トルコ",
          chineseName: "土耳其",
          koreanName: "터키"
        },
        {
          name: "Ukraine",
          code: "UA",
          japaneseName: "ウクライナ",
          chineseName: "乌克兰",
          koreanName: "우크라이나"
        },
        {
          name: "United Kingdom",
          code: "GB",
          japaneseName: "イギリス",
          chineseName: "英国",
          koreanName: "영국"
        },
        {
          name: "Vatican City",
          code: "VA",
          japaneseName: "バチカン市国",
          chineseName: "梵蒂冈",
          koreanName: "바티칸 시국"
        }
      ]
    },
    {
      region: t("apply_visa.continents.north_america"),
      countries: [
        {
          name: "Antigua and Barbuda",
          code: "AG",
          japaneseName: "アンティグア・バーブーダ",
          chineseName: "安提瓜和巴布达",
          koreanName: "앤티구아 바부다"
        },
        {
          name: "Bahamas",
          code: "BS",
          japaneseName: "バハマ",
          chineseName: "巴哈马",
          koreanName: "바하마"
        },
        {
          name: "Barbados",
          code: "BB",
          japaneseName: "バルバドス",
          chineseName: "巴巴多斯",
          koreanName: "바베이도스"
        },
        {
          name: "Belize",
          code: "BZ",
          japaneseName: "ベリーズ",
          chineseName: "伯利兹",
          koreanName: "벨리즈"
        },
        {
          name: "Canada",
          code: "CA",
          japaneseName: "カナダ",
          chineseName: "加拿大",
          koreanName: "캐나다"
        },
        {
          name: "Costa Rica",
          code: "CR",
          japaneseName: "コスタリカ",
          chineseName: "哥斯达黎加",
          koreanName: "코스타리카"
        },
        {
          name: "Cuba",
          code: "CU",
          japaneseName: "キューバ",
          chineseName: "古巴",
          koreanName: "쿠바"
        },
        {
          name: "Dominica",
          code: "DM",
          japaneseName: "ドミニカ",
          chineseName: "多米尼克",
          koreanName: "도미니카"
        },
        {
          name: "Dominican Republic",
          code: "DO",
          japaneseName: "ドミニカ共和国",
          chineseName: "多米尼加共和国",
          koreanName: "도미니카 공화국"
        },
        {
          name: "El Salvador",
          code: "SV",
          japaneseName: "エルサルバドル",
          chineseName: "萨尔瓦多",
          koreanName: "엘살바도르"
        },
        {
          name: "Grenada",
          code: "GD",
          japaneseName: "グレナダ",
          chineseName: "格林纳达",
          koreanName: "그레나다"
        },
        {
          name: "Guatemala",
          code: "GT",
          japaneseName: "グアテマラ",
          chineseName: "危地马拉",
          koreanName: "과테말라"
        },
        {
          name: "Haiti",
          code: "HT",
          japaneseName: "ハイチ",
          chineseName: "海地",
          koreanName: "아이티"
        },
        {
          name: "Honduras",
          code: "HN",
          japaneseName: "ホンジュラス",
          chineseName: "洪都拉斯",
          koreanName: "온두라스"
        },
        {
          name: "Jamaica",
          code: "JM",
          japaneseName: "ジャマイカ",
          chineseName: "牙买加",
          koreanName: "자메이카"
        },
        {
          name: "Mexico",
          code: "MX",
          japaneseName: "メキシコ",
          chineseName: "墨西哥",
          koreanName: "멕시코"
        },
        {
          name: "Nicaragua",
          code: "NI",
          japaneseName: "ニカラグア",
          chineseName: "尼加拉瓜",
          koreanName: "니카라과"
        },
        {
          name: "Panama",
          code: "PA",
          japaneseName: "パナマ",
          chineseName: "巴拿马",
          koreanName: "파나마"
        },
        {
          name: "Saint Kitts and Nevis",
          code: "KN",
          japaneseName: "セントクリストファー・ネイビス",
          chineseName: "圣基茨和尼维斯",
          koreanName: "세인트키츠 네비스"
        },
        {
          name: "Saint Lucia",
          code: "LC",
          japaneseName: "セントルシア",
          chineseName: "圣卢西亚",
          koreanName: "세인트루시아"
        },
        {
          name: "Saint Vincent and the Grenadines",
          code: "VC",
          japaneseName: "セントビンセントおよびグレナディーン諸島",
          chineseName: "圣文森特和格林纳丁斯",
          koreanName: "세인트빈센트 그레나딘"
        },
        {
          name: "United States",
          code: "US",
          japaneseName: "アメリカ合衆国",
          chineseName: "美国",
          koreanName: "미국"
        }
      ]
    },
    {
      region: t("apply_visa.continents.south_america"),
      countries: [
        {
          name: "Argentina",
          code: "AR",
          japaneseName: "アルゼンチン",
          chineseName: "阿根廷",
          koreanName: "아르헨티나"
        },
        {
          name: "Bolivia",
          code: "BO",
          japaneseName: "ボリビア",
          chineseName: "玻利维亚",
          koreanName: "볼리비아"
        },
        {
          name: "Brazil",
          code: "BR",
          japaneseName: "ブラジル",
          chineseName: "巴西",
          koreanName: "브라질"
        },
        {
          name: "Chile",
          code: "CL",
          japaneseName: "チリ",
          chineseName: "智利",
          koreanName: "칠레"
        },
        {
          name: "Colombia",
          code: "CO",
          japaneseName: "コロンビア",
          chineseName: "哥伦比亚",
          koreanName: "콜롬비아"
        },
        {
          name: "Ecuador",
          code: "EC",
          japaneseName: "エクアドル",
          chineseName: "厄瓜多尔",
          koreanName: "에콰도르"
        },
        {
          name: "Guyana",
          code: "GY",
          japaneseName: "ガイアナ",
          chineseName: "圭亚那",
          koreanName: "가이아나"
        },
        {
          name: "Paraguay",
          code: "PY",
          japaneseName: "パラグアイ",
          chineseName: "巴拉圭",
          koreanName: "파라과이"
        },
        {
          name: "Peru",
          code: "PE",
          japaneseName: "ペルー",
          chineseName: "秘鲁",
          koreanName: "페루"
        },
        {
          name: "Suriname",
          code: "SR",
          japaneseName: "スリナム",
          chineseName: "苏里南",
          koreanName: "수리남"
        },
        {
          name: "Uruguay",
          code: "UY",
          japaneseName: "ウルグアイ",
          chineseName: "乌拉圭",
          koreanName: "우루과이"
        },
        {
          name: "Venezuela",
          code: "VE",
          japaneseName: "ベネズエラ",
          chineseName: "委内瑞拉",
          koreanName: "베네수엘라"
        },
        {
          name: "Trinidad and Tobago",
          code: "TT",
          japaneseName: "トリニダード・トバゴ",
          chineseName: "特立尼达和多巴哥",
          koreanName: "트리니다드 토바고"
        }
      ]
    },
    {
      region: t("apply_visa.continents.oceania"),
      countries: [
        {
          name: "Australia",
          code: "AU",
          japaneseName: "オーストラリア",
          chineseName: "澳大利亚",
          koreanName: "호주"
        },
        {
          name: "Fiji",
          code: "FJ",
          japaneseName: "フィジー",
          chineseName: "斐济",
          koreanName: "피지"
        },
        {
          name: "Kiribati",
          code: "KI",
          japaneseName: "キリバス",
          chineseName: "基里巴斯",
          koreanName: "키리바시"
        },
        {
          name: "Marshall Islands",
          code: "MH",
          japaneseName: "マーシャル諸島",
          chineseName: "马绍尔群岛",
          koreanName: "마셜 제도"
        },
        {
          name: "Micronesia",
          code: "FM",
          japaneseName: "ミクロネシア",
          chineseName: "密克罗尼西亚",
          koreanName: "미크로네시아"
        },
        {
          name: "Nauru",
          code: "NR",
          japaneseName: "ナウル",
          chineseName: "瑙鲁",
          koreanName: "나우루"
        },
        {
          name: "New Zealand",
          code: "NZ",
          japaneseName: "ニュージーランド",
          chineseName: "新西兰",
          koreanName: "뉴질랜드"
        },
        {
          name: "Palau",
          code: "PW",
          japaneseName: "パラオ",
          chineseName: "帕劳",
          koreanName: "팔라우"
        },
        {
          name: "Papua New Guinea",
          code: "PG",
          japaneseName: "パプアニューギニア",
          chineseName: "巴布亚新几内亚",
          koreanName: "파푸아뉴기니"
        },
        {
          name: "Samoa",
          code: "WS",
          japaneseName: "サモア",
          chineseName: "萨摩亚",
          koreanName: "사모아"
        },
        {
          name: "Solomon Islands",
          code: "SB",
          japaneseName: "ソロモン諸島",
          chineseName: "所罗门群岛",
          koreanName: "솔로몬 제도"
        },
        {
          name: "Tonga",
          code: "TO",
          japaneseName: "トンガ",
          chineseName: "汤加",
          koreanName: "통가"
        },
        {
          name: "Tuvalu",
          code: "TV",
          japaneseName: "ツバル",
          chineseName: "图瓦卢",
          koreanName: "투발루"
        },
        {
          name: "Vanuatu",
          code: "VU",
          japaneseName: "バヌアツ",
          chineseName: "瓦努阿图",
          koreanName: "바누아투"
        },
        {
          name: "American Samoa",
          code: "AS",
          japaneseName: "アメリカンサモア",
          chineseName: "美属萨摩亚",
          koreanName: "미국령 사모아"
        },
        {
          name: "French Polynesia",
          code: "PF",
          japaneseName: "フランス領ポリネシア",
          chineseName: "法属波利尼西亚",
          koreanName: "프랑스령 폴리네시아"
        },
        {
          name: "New Caledonia",
          code: "NC",
          japaneseName: "ニューカレドニア",
          chineseName: "新喀里多尼亚",
          koreanName: "뉴칼레도니아"
        },
        {
          name: "Wallis and Futuna",
          code: "WF",
          japaneseName: "ワリス・フツナ",
          chineseName: "瓦利斯和富图纳",
          koreanName: "왈리스 푸투나"
        }
      ]
    }
  ];

  const handleNavigateToDetails = (countryName: string) => {
    if (countryName) {
      navigate("../" + path.VISA_REQUIREMENT_DETAILS, {
        state: {
          countryName: countryName
        }
      });
    }
  };

  useEffect(() => {}, [selectedCountry]);

  return (
    <div className="w-full flex flex-col justify-center items-center">
      <RequirementsHeroSection
        countries={countryGroups}
        setSelectedCountry={setSelectedCountry}
      />

      <div className="w-full flex flex-col gap-20 justify-center items-center px-6 py-20">
        <div className="w-full max-w-standard">
          <p className="text-primary-blue font-bold text-justify">
            {t("visa_requirements.description1")}
            <br />
            <br />
            {t("visa_requirements.description2")}
          </p>
        </div>

        <div className="w-full max-w-outer pl-20">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-6">
            {countryGroups.map((group) => (
              <div key={group.region} className="space-y-4">
                {/* Khu vực */}
                <h3 className="text-[22px] text-primary-blue">
                  {group.region}
                </h3>
                {/* Danh sách quốc gia */}
                <div className="flex flex-col space-y-2">
                  {group.countries.map((country) => (
                    <div
                      key={country.code}
                      className="flex gap-1 items-center justify-start cursor-pointer text-center w-full py-1"
                      onClick={() => handleNavigateToDetails(country.name)}
                    >
                      <img
                        alt="flag-img"
                        src={`https://countryflagsapi.netlify.app/flag/${country.code}.svg`}
                        className="h-3 w-5 object-cover rounded-sm"
                      ></img>
                      <p className="text-xs text-left ml-1">
                        {localStorage.getItem("i18nextLng") === "en"
                          ? country.name
                          : localStorage.getItem("i18nextLng") === "jp"
                          ? country.japaneseName
                          : localStorage.getItem("i18nextLng") === "cn"
                          ? country.chineseName
                          : country.koreanName}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default VisaRequirements;
